import { FC } from "react";
import "../../../styles/Home/Modules/Modules.css";
import { ModuleItem } from "./ModuleItem";

const modules = [
    {
        image: "wooblazz-mail",
        title: "Integrasi Email",
        description: "Hubungkan akun atau bikin email untuk kirim penawaran & berkomunikasi lebih formal kepada calon klien"
    },
    {
        image: "wooblazz-ads",
        title: "Iklan Interaktif",
        description: "Promosi produk tidak pernah semenarik ini, Anda dapat berinteraksi dengan calon klien dan dibantu oleh bot"
    },
    {
        image: "wooblazz-chat",
        title: "Integrasi WhatsApp",
        description: "Chat dengan semua klien Anda dari satu dasbor. Tidak perlu beralih platform. Dilengkapi 'fitur bantuan' manajer ke tim."
    }
]

const Modules: FC = () => {
    return (
        <div className="pb-5 bg-modules">
            <h1 className="fw-bold text-black"><span className="text-orange-1 arch-underline">3 Modul</span> Wooblazz</h1>
            <div className="d-flex justify-content-center">

                <div className="row pt-5 pb-5 w-75 gap-4 gap-lg-0">
                    {
                        modules.map((module, index) => (
                            <ModuleItem key={index} image={module.image} title={module.title} description={module.description} />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export { Modules }